/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages

        if(!$('body').hasClass('login')) {
            $(document).foundation(); // Foundation JavaScript
        }

        //init webnerds functions
        stickyHeader();
        mobileSidebar();
        autoScrollToAnchor();
        siteHeaderSubMenu();

        $('.question').click(function(e){
          $(this).parent().find('.answer').slideToggle(50);
          $(this).parent().find('.marker').toggleClass('up');
        });

        if($(".team-leader-settings").length) {
            gform.addFilter( 'gform_datepicker_options_pre_init', function( optionsObj, formId, fieldId ) {
                if ( fieldId == 3 ) {
                    optionsObj.minDate = 0;
                    optionsObj.changeMonth = false;
                    optionsObj.changeYear = false;
                    optionsObj.monthNames = ['Januari','Februari','Mars','April','Maj','Juni','Juli','Augusti','September','Oktober','November','December'];
                    optionsObj.monthNamesShort = ['Jan','Feb','Mar','Apr','Maj','Jun','Jul','Aug','Sep','Okt','Nov','Dec'];
                    optionsObj.dayNamesShort = ['Söndag','Måndag','Tisdag','Onsdag','Torsdag','Fredag','Lördag'];
                    optionsObj.dayNamesMin = ['Sö','Må','Ti','On','To','Fr','Lö'];
                }
                return optionsObj;
            });
        }

        var removeHash = false;

        if (window.location.search.indexOf('profile-updated=1') > -1) {
			$("#profileUpdatedModal").foundation('open');
            removeHash = true;
		}

        if (window.location.search.indexOf('order-updated=1') > -1) {
			$("#orderUpdatedModal").foundation('open');
            removeHash = true;
		}

        if (window.location.search.indexOf('settings-updated=1') > -1) {
			$("#settingsUpdatedModal").foundation('open');
            removeHash = true;
		}

        if (window.location.search.indexOf('period-created=1') > -1) {
			$("#periodCreatedModal").foundation('open');
            removeHash = true;
		}

        if(removeHash == true) {
			window.history.pushState("object or string", "Title", "/"+window.location.href.substring(window.location.href.lastIndexOf('/') + 1).split("?")[0]); //Remove get parameters from URL; prevent modal from showing again on page reload
		}

        $('a[data-open]').on('click', function(e) {
            e.preventDefault();
        });

      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    },
    'login' : {
        init: function() {
            //$("label[for='user_login']").contents().first().remove();

            $("label[for^='user_']").each(function() {
                $(this).find('input').attr('placeholder', $(this).contents().first().text());
                $(this).contents().first().remove();
            });

            $("label[for^=user_login] input").after('<i class="fa fa-user-circle" aria-hidden="true"></i>');

            $("label[for^=user_email] input").after('<i class="fa fa-envelope" aria-hidden="true"></i>');

            $("label[for^=user_pass] input").after('<i class="fa fa-lock" aria-hidden="true"></i>');

            $("label[for^=user_class_code] input").after('<i class="fa fa-hashtag" aria-hidden="true"></i>');

            $("label[for^=user_first_name] input").after('<i class="fa fa-user-circle" aria-hidden="true"></i>');

            $("#nav").contents().eq(2).remove();
        }
    },
    'login_action_login' : {
        init: function() {
            $("#loginform").prepend("<h3>Logga in</h3>");
        }
    },
    'login_action_lostpassword' : {
        init: function() {
            $("#lostpasswordform").prepend("<h3>Återställ Lösenord</h3>");
        }
    },
    'login_action_register' : {
        init: function() {
            $("#registerform").prepend("<h3>Registrera användare</h3>");
        }
    },
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
